import React from 'react';
import styles from './LandingPage.module.css';

export default function Bonuses({ bonuses = [], language = 'en' }) {
  if (!bonuses.length) return null;

  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Extras incluidos' : 'Included Bonuses';
  const title = lang === 'es' ? 'Bonos exclusivos' : 'Exclusive Bonuses';

  return (
    <section className={`${styles.section} ${styles.sectionDark}`}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.bonusesGrid}>
          {bonuses.map((b, idx) => {
            const bonusTitle = b.bonus_title ?? b.title ?? b.name ?? 'Bonus';
            const desc = b.bonus_description ?? b.description ?? '';
            const value = b.value_description ?? '';
            return (
              <div key={b.id ?? idx} className={styles.bonusCard}>
                <div className={styles.bonusIcon}>✦</div>
                <div>
                  <div className={styles.bonusTitle}>{bonusTitle}</div>
                  {desc ? <div className={styles.bonusDesc}>{desc}</div> : null}
                  {value ? <div className={styles.bonusValue}>{value}</div> : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
